import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const BreadcrumbsShowMobileWrapper = styled('div')(
    ({ theme }) => css`
        margin-top: ${theme.spacing['32px']};

        ${theme.mq.large} {
            display: none;
        }
    `
);
